import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { faqData } from 'src/interface/faq';

@Component({
  selector: 'app-faq-listing',
  templateUrl: './faq-listing.component.html',
  styleUrls: ['./faq-listing.component.scss']
})
export class FaqListingComponent implements OnInit, OnDestroy {
  journal_id: string;
  faqArray: faqData[] = [];
  sample = "";
  subscriptionArr: Subscription[] = [];

  constructor(private route: ActivatedRoute,
    private faqservice: GetArticlesService,
    private cd: ChangeDetectorRef) {
    this.sample = "vvvv";

    // this.journal_id = this.route.snapshot.params['journal_id'] != undefined ? this.route.snapshot.params['journal_id'] : this.journal_id;

    //this.getFaqData(this.journal_id);
  }
  ngOnInit() {
    this.journal_id = this.route.snapshot.params['journal_id'] != undefined ? this.route.snapshot.params['journal_id'] : this.journal_id;
    this.getFaqData(this.journal_id);
  }


  getFaqData(journal_id: string) {
    const objfaq = {
      journal_id: journal_id
    }
    const subscription = this.faqservice.getFaqData(objfaq).subscribe(result => {
      this.faqArray = result.data;

    })
    this.subscriptionArr.push(subscription);

  }
  ngOnDestroy() {
    this.subscriptionArr.forEach(x => {
      if (!x.closed) {
        x.unsubscribe();
      }
    });
  }


}

